<template>
    <!-- ローディング画面 -->
    <LoadingScreen v-if="isLoading" />

    <div v-else>
      <!-- メイン画面 -->
      <div>
        <PageNavigation />
        <!-- お知らせ情報 -->
        <div class="margin-section">
            <div>
                <InsertImage titlePage="INFORMATION" titlePageJP="お知らせ"/>
            </div>
            <div v-if="news" class="half-content">
                <article>        
                                            <!-- パンくずリスト -->
                    <nav aria-label="breadcrumb" class="breadcrumb">
                        <ul>
                            <li>
                                <router-link :to="{ path: '/', hash: '#news-list' }">お知らせ一覧</router-link>
                            </li>
                        </ul>
                    </nav>           
                    <div class="post-news" v-fade-in>
                        <p style="font-weight: bolder;margin-bottom: 0;margin-top: 1.7em"><small>{{ news.date }}</small></p>
                        <div>
                            <div class="title-row">
                                <h3>{{ news.title }}</h3>
                                <span
                                    class="news-type-tag"
                                    :style="{
                                        backgroundColor: getNewsTypeColor(news.type).background,
                                        color: getNewsTypeColor(news.type).color,
                                        borderColor: getNewsTypeColor(news.type).border,
                                    }"
                                >{{ news.type || 'その他' }}</span>
                            </div>
                            <p v-html="formatContent(news.content)" class="post-content"></p>
                        </div>
                    </div>
                </article>
            </div>
            <div v-else><p>該当するお知らせ情報はありません。</p></div>
        </div>
        <PageFooter />
      </div>
    </div>
  </template>

<script>
import { formatContent } from '@/utils/utils';
import { getNewsTypeColor } from '@/utils/newsTypes';

import PageNavigation from '@/components/PageNavigation.vue';
import PageFooter from '@/components/PageFooter.vue';
import newsService from '@/services/newsService';
import LoadingScreen from '@/components/LoadingScreen.vue';
import InsertImage from '@/components/InsertImage.vue';

export default {
    name: 'HomePage',
    components: {
      PageNavigation,
      PageFooter,
      LoadingScreen,
      InsertImage,
    },
    props: {
        newsId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            news: null, // 選択されたお知らせデータ
            isLoading: true // ローディング状態
        };
    },
    created() {
        this.fetchNews();
    },
    methods: {
        formatContent,
        getNewsTypeColor,
        async fetchNews() {
            try {
                const newsId = this.$route.params.newsId;
                console.log('newsId: ',newsId);
                this.news = await newsService.getNews(newsId); 
            } catch (error) {
                console.error('お知らせの読み込みに失敗しました:', error);
            } finally {
                this.isLoading = false; // ローディング終了
            }
        },
    }
  };
</script>

<style scoped>

.post-news {
  display: flex;
  justify-content: start;
  align-items:flex-start;
  text-align: left;
  height: auto;
  margin: 30px 3vw;
  gap: 30px;
}

.post-content {
    margin-top: 5vh;
    line-height: 2;
}

.title-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.news-type-tag {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid;
    font-size: 13px;
    font-weight: bold;
    white-space: nowrap;
}

.post-news small {
    white-space: nowrap;
}

/* 戻るボタンのスタイル */
.back-button-container {
    text-align: center;
    margin: 30px 0;
}

.back-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.back-button:hover {
    background-color: #0056b3;
}

/* スマートフォン対応 */
@media (max-width: 768px) {
    .post-news {
        display: block;
        align-items:flex-start;
        text-align: left;
        height: auto;
        margin: 30px 5vw;
        gap: 30px;
    }
    
    .back-button {
        font-size: 12px;
        padding: 6px 12px;
    }
}
</style>